import Component from "../../components/PushNotificationsPrompt/PushNotificationsPrompt";
import {useContext, useEffect, useState} from "preact/hooks";
import {GlobalContext} from "../../contexts/GlobalContext";

const PushNotificationsPrompt = ({}) => {
  const [canEnableNotifications, setCanEnableNotifications] = useState(false);
  const { options } = useContext(GlobalContext);

  const updateEnableNotifications = () => {
    OneSignal.push(() => {
      const isPushSupported = OneSignal.isPushNotificationsSupported();
      OneSignal.isPushNotificationsEnabled(function(isEnabled) {
        OneSignal.push([
          "getNotificationPermission",
          function(permission) {
            const canEnable =
              isPushSupported &&
              !isEnabled &&
              permission !== "denied" &&
              permission !== "granted";
            setCanEnableNotifications(canEnable && !options.hideNotificationsPrompt);
          }
        ]);
      });
    });
  };

  useEffect(() => {
    updateEnableNotifications();
  }, []);

  useEffect(() => {
    OneSignal.push(function() {
      // Occurs when the user's subscription changes to a new value.
      OneSignal.on("subscriptionChange", function() {
        updateEnableNotifications();
      });
    });
  }, []);

  const enableNotifications = () => {
    OneSignal.showNativePrompt();
  };

  return <Component canEnableNotifications={canEnableNotifications} onEnableNotifications={enableNotifications} />;
};

export default PushNotificationsPrompt;



// WEBPACK FOOTER //
// ./containers/PushNotificationsPrompt/PushNotificationsPrompt.js